import React from 'react';
import { CardActions } from '@material-ui/core';
import PropTypes from 'prop-types';
import CardHeader from '@material-ui/core/CardHeader';
import Divider from '@material-ui/core/Divider';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import { useHistory } from 'react-router-dom';
import View from '../../../components/RxForm/View/index';
import RxFormProvider from '../../../components/RxForm/RxFormProvider';
import { useRxForm } from '../../../components/RxForm/hooks';
import CompletedCaseModificationWarning from '../../../components/CompletedCaseModificationWarning';

const RxFormInfo = ({ rxForm, modifiable, additionalButtons, redirectToModifyPage, ...props }) => {
  return (
    <Card {...props}>
      <CardHeader title="RxForm" />
      <Divider />
      <CardContent>
        <View rxForm={rxForm} />
      </CardContent>
      <Divider />
      <CardActions>
        {additionalButtons()}
        {modifiable && (
          <Button
            variant="contained"
            color="primary"
            title="Modify"
            style={{ marginLeft: 'auto' }}
            onClick={redirectToModifyPage}
          >
            Edit
          </Button>
        )}
      </CardActions>
    </Card>
  );
};

RxFormInfo.defaultProps = {
  additionalButtons: ''
};

RxFormInfo.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  rxForm: PropTypes.object.isRequired,
  modifiable: PropTypes.bool.isRequired,
  additionalButtons: PropTypes.func,
  redirectToModifyPage: PropTypes.func.isRequired
};

const WithRxForm = props => {
  const history = useHistory();
  const { rxForm, modificationRules } = useRxForm();
  const [modify, setModify] = React.useState(false);

  const { patient } = props;

  return (
    <>
      <RxFormInfo
        rxForm={rxForm}
        modifiable={Object.values(modificationRules).some(rule => rule && rule.updatable)}
        redirectToModifyPage={() => setModify(true)}
        {...props}
      />
      {modify && (
        <CompletedCaseModificationWarning
          patient={patient}
          cancel={() => setModify(false)}
          proceed={() => history.push(`/rx-forms/${rxForm.id}/modify`)}
        />
      )}
    </>
  );
};

WithRxForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  patient: PropTypes.object.isRequired
};

const Wrapper = ({ id, ...props }) => {
  return (
    <RxFormProvider id={id} withPreference>
      <WithRxForm {...props} />
    </RxFormProvider>
  );
};

Wrapper.propTypes = {
  id: PropTypes.number.isRequired
};

export default Wrapper;
